import Vue from "vue";
import Echarts from "vue-echarts";

import "echarts/lib/chart/line";

Vue.component("chart", Echarts);
